<template>
    <div>
    user settings
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>